/**
* In this file contains common function codes
**/
import CryptoJS  from 'crypto-js';
import elliptic from 'elliptic';
import * as moment from 'moment';
import ApiService from './../services/ApiService';
import { PhoneNumberUtil } from 'google-libphonenumber';


 /**
   @Decryption-Method
   This function is used to create private key
   @password - User Id or User password or encrypted Msg
   @encryptedData- UserEpk or PassEPK(Encrypted text) or sharedKey
 **/
 const generatePrivateKey = (password, encryptedData) => {
	 
	try{	 
		// Split the encryptedData into IV and encryptedMessage
		const [IV, encryptedMessage] = encryptedData.split(':');

		// Convert userId to SHA-256 Hash-key in WordArray
		const passwordHash = CryptoJS.SHA256(password);

		// Convert HashBytes to Base64
		let passHashBase64 = passwordHash.toString(CryptoJS.enc.Base64);

		// Checking Base64 length
		passHashBase64 = passHashBase64.length > 32 ? passHashBase64.substring(0, 32) : passHashBase64;

		// Convert base64 key to WordArray
		const keySpec = CryptoJS.enc.Utf8.parse(passHashBase64);

		const cipherParams = CryptoJS.lib.CipherParams.create({
			ciphertext: CryptoJS.enc.Hex.parse(encryptedMessage)
		  });
		  
		// Initiate Cipher for Decryption
		const decipher = CryptoJS.AES.decrypt(cipherParams, keySpec, {
		  iv: CryptoJS.enc.Hex.parse(IV),
		  mode: CryptoJS.mode.CTR,
		  padding: CryptoJS.pad.NoPadding
		});

		// Decrypt the encrypted message
		const decryptedMessage = CryptoJS.enc.Utf8.stringify(decipher);
		return decryptedMessage;
		
    }catch(error){
		console.log('generatePrivateKey',error);
	}
 }

 /** 
 * @Encryption-method
 * This function is used to generate passwordEPK when update the password
 * @password - User password or plain text msg
 * @key - private key or shared key
 * @return passwordEPK 
 **/
 
 const generatePasswordEPK=(password,key)=>{
	
   try{
	  // Generate a random IV (Initialization Vector)
      const iv = CryptoJS.lib.WordArray.random(16);

	  // Convert the password to SHA-256 Hash-key in WordArray
	  const passwordHash = CryptoJS.SHA256(password);

	  // Convert HashBytes to Base64
	  let passHashBase64 = passwordHash.toString(CryptoJS.enc.Base64);

	  // Checking Base64 length
	  passHashBase64 = passHashBase64.length > 32 ? passHashBase64.substring(0, 32) : passHashBase64;

	  // Convert base64 key to WordArray
	  const keySpec = CryptoJS.enc.Utf8.parse(passHashBase64);

	  // Encrypt the data using AES
	  const encryptedMessage = CryptoJS.AES.encrypt(key, keySpec, {
		iv: iv,
		mode: CryptoJS.mode.CTR,
		padding: CryptoJS.pad.NoPadding
	  }).ciphertext.toString(CryptoJS.enc.Hex);

	  // Combine IV and encrypted message
	  const encryptedData = `${iv}:${encryptedMessage}`;

      return encryptedData;
	  
   }catch(error){
	   
		console.log('generatePasswordEPK',error);
	}
}


/** 
 * This function is used to hash the user password in encrypted format
   @plainTextMessage = plain user password
   return - Encrypted password
 **/
const hashPassword = (plainTextMessage) => {
   try {
    if (plainTextMessage === '') {
      return '';
    }
    const salt = CryptoJS.enc.Hex.parse(getRandomHexString(32).toLowerCase());
	
    const key = CryptoJS.PBKDF2(process.env.REACT_APP_SECRETKEY, salt, {
      keySize: 256 / 32,
      iterations: 100,
      hasher: CryptoJS.algo.SHA1,
    });
    const randomIV = CryptoJS.enc.Hex.parse(getRandomHexString(32).toLowerCase());
    const secret = CryptoJS.enc.Hex.parse(key.toString());
    const ivSpec = CryptoJS.enc.Hex.parse(randomIV.toString());
    const encrypted = CryptoJS.AES.encrypt(plainTextMessage, secret, {
      iv: ivSpec,
      padding: CryptoJS.pad.Pkcs7,
    });
    const saltText = salt.toString();
    const ivText = randomIV.toString();
    const cipherText = encrypted.ciphertext.toString();
    const finalText = saltText.concat(ivText).concat(cipherText);
    const finalResult = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(finalText));

    return finalResult;
  } catch (e) {

    return '';
  }
}

/**
* To encrypt password when login to handle update password
* @plaintext pass the user typed tesing in string format 
**/
const encryptPassword=(plaintext)=>{
	const encrypted = CryptoJS.AES.encrypt(plaintext, process.env.REACT_APP_SECRETKEY).toString();
	return encrypted;
	
};

/** 
* To decrypt password when login to handle update password
* @encryptedText pass the encryptedText in String format
**/
const decryptPassword=(encryptedText)=>{
	const decryptedData = CryptoJS.AES.decrypt(encryptedText, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

/**
* To return random HEX string
* @length pass how many length that HEX string want to have
**/
const getRandomHexString = (length) => {
  const characters = 'abcdef0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};


//To go back previous page
const goBack=()=>{	
	return window.history.back();
}

/**
* To convert 24hrs to 12hrs time format
* @time24 pass the time value in UTC format
**/
function convertTimeFormat(time24) {
  
  var hours = parseInt(time24.substring(0, 2));
  var minutes = time24.substring(3);

  var suffix = hours >= 12 ? "PM" : "AM";

  hours = ((hours + 11) % 12) + 1;

  var time12 = hours + ":" + minutes + " " + suffix;
  return time12;
}

/**
* To convert UTCtolocalDate
* @data pass thet time value in UTC format
**/
function convertUTCtoLocal(data){
	if(data === null || data === undefined || data === ''){
		return '--';
	}
const options = { year: 'numeric', month: 'short', day: 'numeric' };
const localDate = new Date(data).toLocaleDateString('en-US', options);

return localDate;

}

/**
* To convert Date to time
* @date pass the date value in UTC format
**/
function convertDateToTime(date){
	if(date){
	return moment(date).format('HH:mm');
	}else{
		return '';
	}
}

/**
* To convert time to date
* @time pass the time value in UTC format
**/
function convertTimeToDate(time){
	if(time){
	const currentDate = moment();
	const combinedDateTime = moment(currentDate).set({
	  hour: moment(time, 'HH:mm').hours(),
	  minute: moment(time, 'HH:mm').minutes()
	});
	return new Date(combinedDateTime);
	}else{
		return null;
	}

}

/**
 * Converts a Date string in "hh:mm A" format to "HH:mm" format.
 * @param {string} date - The time in "hh:mm A" format.
 * @returns {string} - The time in "HH:mm" format, or an empty string if invalid.
 */
function convert_DateToTime(date) {
    const momentDate = moment(date, "hh:mm A", true); // Strict parsing
    if (!momentDate.isValid()) {
        console.error("Invalid time format:", date);
        return "";
    }
    return momentDate.format("HH:mm"); // 24-hour format
}

/**
* To convert the image base64 to blob type
* @dataURI pass the image or document base64 format
**/
const dataURItoBlob = (dataURI) => {
  const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
};


	 
	 /** 
	 * To generate shared key 
	 * @privKey- User private key 
	 * @pubKey- Receiver public key 
	 * return sharedKey
	 **/
	 const generateSharedKey = (privKey,pubKey) =>{
		  const ecdh = new elliptic.ec('p521');
		  const userKey = ecdh.keyFromPrivate(privKey, 'hex');
		  const otherUserKey = ecdh.keyFromPublic(pubKey, 'hex');
		  const sharedKey = userKey.derive(otherUserKey.getPublic());
		  var key= sharedKey.toString('hex');	  
		  return key.length >=132?key:checkSharedKey(key);
	 }
	 
	 /** 
	 * To check shared key is valid or not
	 * @key- pass the generateSharedKey value
	 **/
	 function checkSharedKey(key) {
			const zerosToAdd = 132 - key.length;
			const zeros = Array(zerosToAdd).fill('0').join('');
			return zeros + key;
	}

	 /**
	 * To convert DOB to AGE
	 * @date pass the date value in UTC format
	 **/
	 const convertDOBtoAge=(data, t)=>{
		 if (data === null || data === undefined) {
			 return '--';
		 }
		 
			// Current date
			var currentDate = new Date();

			// Extract year, month, and day from the DOB string
			var dobParts = data?.split("-");
			var dobYear = parseInt(dobParts[0]);
			var dobMonth = parseInt(dobParts[1]) - 1; // Month is 0-indexed in JavaScript Date
			var dobDay = parseInt(dobParts[2]);

			// Create a new Date object with the DOB
			var birthdate = new Date(dobYear, dobMonth, dobDay);

			// Calculate the age in months and years
			var ageInMonths = (currentDate.getFullYear() - birthdate.getFullYear()) * 12 + (currentDate.getMonth() - birthdate.getMonth());
			// Adjust for remaining days in the current month
				if (currentDate.getDate() < birthdate.getDate()) {
				  ageInMonths--;
				}

			//var years = Math.floor(ageInMonths / 12);
			//var months = ageInMonths % 12;
			var years = Math.abs(Math.floor(ageInMonths / 12));
			var months = Math.abs(ageInMonths % 12);
			   // Calculate the remaining days
			  var timeDiff = Math.abs(currentDate.getTime() - birthdate.getTime());
			  var days = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
            
			  if (years === 0) {
				if (months === 0) {
				  if (days === 0) {
					return t('common.birth');
				  } else if (days === 1){
					  return days + ` ${t('common.day')}`;
				  }
				  else {
					return days + ` ${t('common.days')}`;
				  }
				} else if (months === 1){
					return months + ` ${t('common.mon')}`;
				} else {
				  return months + ` ${t('common.mons')}`;
				}
			  }
			  else {
				if (months === 0 && years === 1) {	
					return years + ` ${t('common.yr')}`;	
				} else if (months === 0){
					return years +  ` ${t('common.yrs')}`;
				} else {
					return years +  ` ${t('common.yrs')} ` + months +  ` ${t('common.mons')}`;
				}
			  }
	 }
	 
	 
		
		/**
		* To convert the DOB to development stage
		* @dob pass the date of birth date value
		**/
		const convertDOBtoDevStage =(dob,t)=>{
			  const today = new Date();
			  const birthDate = new Date(dob);

			  const timeDiff = Math.abs(today.getTime() - birthDate.getTime());
			  const diffMonths = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 30));
			  const diffYears = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
              
			  if (diffMonths >= 0 && diffMonths < 2) {
				return  `0-2 ${t('common.months')}`;
			  } else if (diffMonths >= 2 && diffMonths < 4) {
				return `2-4 ${t('common.months')}`;
			  } else if (diffMonths >= 4 && diffMonths < 6) {
				return `4-6 ${t('common.months')}`;
			  } else if (diffMonths >= 6 && diffMonths < 9) {
				return `6-9 ${t('common.months')}`;
			  } else if (diffMonths >= 9 && diffMonths < 12) {
				return `9-12 ${t('common.months')}`;
			  }else if (diffMonths >= 12 && diffMonths < 15) {
				return `12-15 ${t('common.months')}`;
			  }else if (diffMonths >= 15 && diffMonths < 18) {
				return `15-18 ${t('common.months')}`;
			  } else if (diffMonths >= 18 && diffYears < 2) {
				return `18 ${t('common.months')}-2 ${t('common.years')}`;
			  }else if (diffYears >= 2 && diffYears < 2.5) {
				return `2 ${t('common.years')}-2.5 ${t('common.years')}`;
			  }else if (diffYears >= 2.5 && diffYears < 3) {
				return `2.5 ${t('common.years')}-3 ${t('common.years')}`;
			  } else {
				return '--';
			  }
		};
		
		/**
		* To convert DOB to age rage ID
		* @dob pass the date of birth date value
		**/
		const convertDOBtoAgerangeId=(dob)=>{
			  const today = new Date();
			  const birthDate = new Date(dob);

			  const timeDiff = Math.abs(today.getTime() - birthDate.getTime());
			  const diffMonths = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 30));
			  const diffYears = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));

			  if (diffMonths >= 0 && diffMonths < 2) {
				return 1;
			  } else if (diffMonths >= 2 && diffMonths < 4) {
				return 2;
			  } else if (diffMonths >= 4 && diffMonths < 6) {
				return 3;
			  } else if (diffMonths >= 6 && diffMonths < 9) {
				return 4;
			  } else if (diffMonths >= 9 && diffMonths < 12) {
				return 5;
			  }  else if (diffMonths >= 12 && diffMonths < 15) {
				return 6;
			  } else if (diffMonths >= 15 && diffMonths < 18) {
				return 7;
			  } else if (diffMonths >= 18 && diffYears < 2) {
				return 8;
			  } else if (diffYears >= 2 && diffYears < 2.5) {
				return 9;
			  }else if (diffYears >= 2.5 && diffYears < 3) {
				return 10;
			  } else {
				return 0;
			  }
			
		}
		
		/**
		* To convert DOB to Month
		* @dob pass the date of birth date value
		**/
		const convertDOBtoMonth=(dob)=>{
			
			const currentDate = moment();
			const duration = moment.duration(currentDate.diff(dob));
			return Math.floor(duration.asMonths());
            		
		}
		
		
       /**
	   * To check development milestone question answer(Yes or No)
	   * @age pass the development agerange masterVale
	   * @question pass the question id
	   * @data pass the particular agerange question JSON values
	   **/
	   const checkMilestoneAnswer=(age,question,data)=>{
		   if(data.length !==0){	   
			   return data.map((a,ix)=>{
				  if(parseInt(a.id)===question){
					  return <i key={ix} className={a.value.toLowerCase()==='yes'?"fa-solid fa-square-check text-tmGreen align-middle  h6 ms-1":"fa-solid fa-square-xmark align-middle h6 text-danger ms-1"}></i>;
				  }
				  return '';
			   });
		   } 
	   }
	   
	  /**
	  * To Convert the Measurement values into whole values
	  * @value pass the Measurement value
	  **/
	   const formatMeasurement=(value) =>{
		  if (!value) return '--';

		  const parsedValue = parseFloat(value);
		  if (Number.isInteger(parsedValue)) {
			return `${parseInt(parsedValue)}`;
		  } else {
			// Convert to string with one decimal place
			const formattedValue = parsedValue.toFixed(1);
			
			// Remove trailing zeros if present
			const trimmedValue = parseFloat(formattedValue).toString();
			
			return trimmedValue;
		  }
		}
       
	   /** 
	   * To convert the s3 image private to public or server file folder access
	   * @imageurl pass the image name
	   * @expiry pass the expiry time for this created utl
	   **/
	   const convertS3privateToPublic=(imageurl,expiry?)=>{
		  if(imageurl){
		  return process.env.REACT_APP_SERVERURL+imageurl;
		  }
	   };
	   
	   //To get browser information
	  const getBrowserInfo=()=> {
		  const userAgent = navigator.userAgent;
		  let browserName = '';
		  let browserVersion = '';
		  let osVersion = '';

		  // Get browser information
		  if (/Firefox/i.test(userAgent)) {
			browserName = 'Firefox';
			const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  } else if (/Edg/i.test(userAgent)) {
			browserName = 'Edge';
			const match = userAgent.match(/Edg\/(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  } else if (/Chrome/i.test(userAgent)) {
			browserName = 'Chrome';
			const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  } else if (/Safari/i.test(userAgent)) {
			browserName = 'Safari';
			const match = userAgent.match(/Version\/(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  } else if (/Opera|OPR/i.test(userAgent)) {
			browserName = 'Opera';
			const match = userAgent.match(/(?:Opera|OPR)\/(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  } else if (/Trident|MSIE/i.test(userAgent)) {
			browserName = 'Internet Explorer';
			const match = userAgent.match(/(?:Trident\/|MSIE )(\d+\.\d+)/);
			if (match) {
			  browserVersion = match[1];
			}
		  }

		  // Get OS version
		  if (/Windows NT 10\.0/.test(userAgent)) {
			osVersion = 'Windows 10';
		  } else if (/Windows NT 6\.3/.test(userAgent)) {
			osVersion = 'Windows 8.1';
		  } else if (/Windows NT 6\.2/.test(userAgent)) {
			osVersion = 'Windows 8';
		  } else if (/Windows NT 6\.1/.test(userAgent)) {
			osVersion = 'Windows 7';
		  } else if (/Windows NT 6\.0/.test(userAgent)) {
			osVersion = 'Windows Vista';
		  } else if (/Windows NT 5\.1/.test(userAgent)) {
			osVersion = 'Windows XP';
		  } else if (/Mac/.test(userAgent)) {
			osVersion = 'MacOS';
		  } else if (/Linux/.test(userAgent)) {
			osVersion = 'Linux';
		  } else if (/Android/.test(userAgent)) {
			osVersion = 'Android';
		  } else if (/iOS/.test(userAgent)) {
			osVersion = 'iOS';
		  }

		  return { webBrowserType:browserName, webBrowserVersion:browserVersion, OSVersion:osVersion };
		}

		// To return browser make string
		function getMakeFromBrowser(browserName) {
			switch (browserName) {
				case "Chrome":
				return "Google";
				case "Firefox":
				return "Mozilla";
				case "Edge":
				return "Microsoft";
				case "Safari":
				return "Apple";
				case "Opera":
				return "Opera Software";
				case "Internet Explorer":
				return "Microsoft";
				default:
				return "Unknown";
			}
		}
	   
	   //To return the Analytics Request data
	   const analyticsRequest=()=>{
		   var data={
			   ...{
				   appPlatform:'web',
			   appVersion:'1.0.0',
			   deviceType:'browser',
			   operation:'view'
			   },
			   ...getBrowserInfo()
		    }
		   return data;
	   }
	   
	    /**
		* To get city and state from geo location
		* @location pass the Autocomplete's Event values
		**/
	   const filterGeoLocation= async(location, addressOne, addressTwo)=>{		
		if (Object.keys(location).length !== 0 && location && location.address_components && location.address_components.length > 0) {
			// Extract city where type is "administrative_area_level_3"
			const city = location.address_components.find(component =>
				component.types.includes("administrative_area_level_3")
			)?.long_name || location.address_components[0].long_name;
			// Extract state where type is "administrative_area_level_1"
			const state = location.address_components.find(component =>
				component.types.includes("administrative_area_level_1")
			)?.long_name || location.address_components[location.address_components.length - 2].long_name;
			// Extract location latitude and longitude values
			let address = location.formatted_address;
			// Check if both addressOne and addressTwo are not null
			if (addressOne !== null && addressTwo !== null) {
				address = `${addressOne}, ${addressTwo}, ${address}`; // Concatenate both
			} else if (addressOne !== null) {
				address = `${addressOne}, ${address}`; // Concatenate addressOne only
			} else if (addressTwo !== null) {
				address = `${addressTwo}, ${address}`; // Concatenate addressTwo only
			}
			 // Fetch the bounding box using the Geocoding API
			 const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyA8t4vIfpNB4PRETgOBkI0wVHITx5k14jI&address=${address}`);
			 const geo_location = await response.json();

			return { city, state, geo_location };
		}		
		   return {state: '' };
	   }
	   
	   /**
	   * To calculate lastSeen user 
	   * @lastActiveTime pass the time value in UTC format
	   **/
	   const lastSeen = (lastActiveTime) => {
			const currentTime = new Date();
		    const seenTime = new Date(lastActiveTime);
			const timeDiff = Math.abs(currentTime - seenTime); // Time difference in milliseconds
			const minsDiff = Math.floor(timeDiff / (1000 * 60)); // Time difference in minutes
			const hoursDiff = Math.floor(minsDiff / 60); // Time difference in hours
			const daysDiff = Math.floor(hoursDiff / 24); // Time difference in days
			if (minsDiff < 60) {
				if(minsDiff===0){
					return `just now`;
				}
				// Less than 60 minutes ago
				return `left ${minsDiff} mins ago`;
			}else if(hoursDiff === 1) {
				return `left ${hoursDiff} hour ago`;
			}else if (hoursDiff < 24) {
				// Less than 24 hours ago
				return `left ${hoursDiff} hours ago`;
			}else if (daysDiff === 1) {
				// Exactly 1 day ago
				return 'left 1 day ago';
			} else if (daysDiff <= 30) {
				// Less than or equal to 30 days ago
				return `left ${daysDiff} days ago`;
			} else if (daysDiff <= 365) {
				// Less than or equal to 365 days ago
				const monthsDiff = Math.floor(daysDiff / 30);
				if (monthsDiff === 1) {
				  return 'left 1 month ago';
				} else {
				  return `left ${monthsDiff} months ago`;
				}
			} else {
				// More than 365 days ago
				const yearsDiff = Math.floor(daysDiff / 365);
				if (yearsDiff === 1) {
				  return 'left 1 year ago';
				} else {
				  return `left ${yearsDiff} years ago`;
				}
			}
	   };
	   
	    /** 
		* To calculate message date
		* @createdAt pass the message created date in UTC format
		**/
	   const getMessageDate = (createdAt) => {
			const today = moment().startOf('day');
			const messageDate = moment(createdAt).startOf('day');
			const yesterday = moment().subtract(1, 'days').startOf('day');
			const dayAfterTomorrow = moment().add(2, 'days').startOf('day');
			

			if (messageDate.isSame(today, 'd')) {
				return 'Today';
			} else if (messageDate.isSame(yesterday, 'd')) {
				return 'Yesterday';
			} else if (messageDate.isSame(dayAfterTomorrow, 'd')) {
				return moment(createdAt).format('DD.MM.YY');
			} else {
				return moment(createdAt).format('MMMM Do, YYYY');
			}
		};
		
		/**
		* To get appointment calendar start date and end date
		* @date pass the appointment time value in UTC format
		**/
		function appointmentEventdates(date) {
			var startDate=new Date(date);
			 var endDate=startDate.setMinutes(startDate.getMinutes() + 30);
			 
			 return {start:date,end:endDate,prevStart:date,prevEnd:endDate};
       }
	   
	   /**
	   * To convert UTCtolocalDate for Appointment UI
	   * @data pass the appointment date value in UTC format
	   **/
		function convertUTCtoLocalDigit(data) {
		  const date = new Date(data);
		  const year = date.getFullYear();
		  const month = String(date.getMonth() + 1).padStart(2, '0');
		  const day = String(date.getDate()).padStart(2, '0');
		  const localDate = `${year}-${month}-${day}`;
		  return localDate; 
		}
		
		/**
		* To convert UTC to Date and Time for graph
		* @dateString pass the appointment created time in UTC format
		**/
		function convertUTCtoDateAndTime(dateString) {
			const date = new Date(dateString);
			const formattedDate = date.toLocaleString("en-US", {
			  day: "numeric",
			  month: "short",
			  year: "2-digit",
			  hour: "numeric",
			  minute: "numeric",
			  hour12: true,
			});
			return formattedDate;
		}
		
		/**
		* To convert the integer to suffix text
		* @integer pass the doseage value in Number
		**/
		function convertIntToSuffix(integer) {
		const currentLang = localStorage.getItem('i18nextLng');
		if (currentLang === 'ta') {
			return 'வது'; // Tamil suffix for all ordinals
		}

		// Default English suffixes
		if (integer === 1) return 'st';
		if (integer === 2) return 'nd';
		if (integer === 3) return 'rd';
		return 'th';
		}

		
		/**
		* To print the vaccination dose by vaccine id and age id
		* vaccine pass the vacccination masterValue
		* age pass the vacccination age masterValue
		* list pass the masterVaccination's mapping value
		* dob pass the member's dob value
		* ageName pass the masterVaccination ageName
		* data pass the particular member vacccination details from the api response
		**/
		function printVaccinationDose(vaccine,age,list,dob,ageName,data,type,t,getLocalizedVaccinationTypeName){
			if(list.length !==0){
				var result=list.filter(i=>i.age===age && i.vaccination ===vaccine);
				if(result.length !==0){
				   if(result[0].span !==0){
					   //var isVaccinated;
					   //To print vaccination in merged cell
					   if(result[0].span){
						 var colList=list.filter(i=>i.vaccineId===result[0].vaccineId && i.vaccination ===vaccine);
						 
						 const mergedData = Object.values(
						  colList.reduce((acc, obj) => {
							const { age, dose, vaccineId, vaccination ,type } = obj;
							acc[age] = acc[age] || { age, dose: [], vaccineId, vaccination, type};
							acc[age].dose.push(dose);
							return acc;
						  }, {})
						);
						
						const mergedData1 = [{
							  age: [...new Set(colList.map(obj => obj.age))],
							  //dose: [...new Set(colList.map(obj => obj.dose))],
							  dose: (colList.map(obj => obj.dose)),
							  vaccination: colList[0].vaccination ,
							  type: [...new Set(colList.map(obj => obj.type))]
							}];
						
						 var tabData;
						 var tabData1;
						    //Table row 1
						    tabData=mergedData.map((a,i)=>{	
							  var check= data.filter(i=>parseInt(i.child_age)===a.age && i.vaccination ===a.vaccination);
							  if(check.length !==0){
							    return <td key={i} valign="middle" align="center" className={check.length>1?"vaccineSubTableGrid":""}>{check.map((item,idx)=>{
									var typeValue = item.type && item.type !==0 ? getLocalizedVaccinationTypeName(item.type) : null;  
									var dose = convertIntToSuffix(item.dose);
							       return <span key={idx}>
									{/*{item.dose}
									<sup >{dose}</sup> Dose<br />*/}
									{(typeValue && typeValue !== null ) ? <span>{typeValue} </span> : null}
									{item.dose !== 0 ? <span>{' '+item.dose > 4 ? item.dose-4 : item.dose}<sup>{dose}</sup>{ item.dose > 4 ? `${t('modal.booster')}`: `${t('common.dose')}`}<br /></span> :  <> {t('common.birth')}</>}
									<i className="fa-solid fa-circle-check text-tmGreen" />
									<br />
									<p className="vaccineDate">
									{convertUTCtoLocal(item.vaccination_date)}
									</p>
									</span>
								})}</td>
				
							  }else{
								 return <td key={i}></td>;
							  }
							  
					     });
						
						 //Table row 2
						 tabData1=mergedData1.map((a,i)=>{	
							  var check= data.filter(i=>a.dose.includes(i.dose) && i.vaccination ===a.vaccination && a.age.includes(parseInt(i.child_age)));
							  if(check.length !==0){
							    return <td key={i}></td>
							  }else{
								  const ordinalArray = a.dose.map((number, i) => {
								  var typeValue = a.type && a.type[i] !== 0 ? getLocalizedVaccinationTypeName(a.type)  : null;
								  return (
									<span key={i}>
									  {typeValue && typeValue !== null ? <span>{typeValue} </span> : null}
									  {number !== 0 ? (
										<span>
										  {' ' + number > 4 ? number-4: number}
									  <sup>{convertIntToSuffix(number)}</sup> {number > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}<br />
										</span>
									  ) : <> {t('common.birth')}</>}
									  {a.dose.length > 1 && a.dose.length - 1 !== i ? `${t('modal.or')}` : ''}
									</span>
								  );
								});

								return <td valign="middle" align="center" key={i}>{ordinalArray}{checkVaccineDoseStatus(ageName, dob, [false])}</td>;
							  }
							  
					     });
						 
						  var subTable= <table className="vaccineSubTable"><tbody><tr >{tabData}</tr><tr >{tabData1}</tr></tbody></table>
						  return <td colSpan={result[0].span} valign="middle" align="center" className="bg-light vacccinationtd">{subTable}</td>
					   }else{/*
						 
						 //To print vaccination in single cell
						 var value= data.filter(i=>parseInt(i.child_age)===age && i.vaccination ===vaccine); 
						 const mergedArray = result.concat(
							value.filter(obj2 => !result.some(obj1 => obj1.dose === obj2.dose))
							  .map(obj => {
								const { child_age, ...rest } = obj;
								return { ...rest, age: child_age };
							  })
						  );
						  //console.log('mergedArraymergedArraymergedArraymergedArray',mergedArray);

					  var span= mergedArray.map((a,i)=>{
							isVaccinated= data.map(i=>parseInt(i.child_age)===age && i.vaccination ===vaccine && i.dose===a.dose);	
							var checkDate= data.filter(i=>parseInt(i.child_age)===age && i.vaccination ===vaccine && i.dose===a.dose);
							var dose = convertIntToSuffix(a.dose)
								const typeValue = a.type && a.type.map(id => {
									const foundItem = type.find(item => item.id === id);
									return foundItem ? foundItem.name : null;
								});
							return (
							<span key={i}>
								{(a.type && a.type.length > 0) ? <span>{typeValue.join(' / ')}<br /></span> : null}
								{a.dose !== 0 ? <span>{a.dose}<sup>{dose}</sup> Dose<br /></span> : null}
								{checkVaccineDoseStatus(ageName,dob,isVaccinated)}<br />
								{checkDate[0]?.vaccination_date?<p className="vaccineDate">{convertUTCtoLocal(checkDate[0]?.vaccination_date)}</p>:''}
							</span>
							);
							//return <span key={i}>{a.dose}<sup >{dose}</sup> Dose<br />{checkVaccineDoseStatus(ageName,dob,isVaccinated)}<br />{checkDate[0]?.vaccination_date?<p className="vaccineDate">{convertUTCtoLocal(checkDate[0]?.vaccination_date)}</p>:''}</span>;
							
					  });
		
					    
					  return <td valign="middle" align="center" colSpan={checkColumnSpanSize(vaccine,age,list)} className={span.length>2?"bg-light d-grid vacccinationtd":"bg-light vacccinationtd"}>{span}</td>;*/
					   
					   }
				   }
				}else{
					//To print vaccination for Empty space
					var filter = data.filter(i=>parseInt(i.child_age)===age && i.vaccination ===vaccine);
					if(filter.length !==0){
					  var spans= filter.map((a,i)=>{				
						  var dose = convertIntToSuffix(a.dose)
						  const typeValue = a.type && a.type !==0 ? getLocalizedVaccinationTypeName(a.type) : null;
						  return <span key={i}>
							{/*{a.dose}
							<sup>{dose}</sup> Dose<br />*/}
							{(typeValue && typeValue !== null ) ? <span>{typeValue} <br /></span> : null}
							{a.dose !== 0 ? <span>{a.dose > 4 ? a.dose-4 : a.dose}<sup>{dose}</sup> { a.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}<br /></span> :  <> {t('common.birth')}</>}
							<i className="fa-solid fa-circle-check text-tmGreen" /><br />
							<p className="vaccineDate">{convertUTCtoLocal(a.vaccination_date)}</p>
						  </span>;
					  });
					  return <td className={filter.length>1?"d-grid":""} valign="middle" align="center">{spans}</td>;
					}else{
					  return <td></td>;
					}
				}	
			}
		}
		
		/**
		* To find the column span for vaccination table head
		* vaccine pass the vacccination masterValue
		* age pass the vacccination age masterValue
		* list pass the masterVaccination's mapping value
		**/
		function checkColumnSpanSize(vaccine,age,list){
			if(list.length !==0){
				var result=list.filter(i=>i.age===age && i.vaccination ===vaccine);
				if(result.length !==0){
					return result[0].span;
				}else{
					return 1;
				}
		    }
		}
		

		/**
		* To check the vacccination dose status
		* @value pass the masterVaccination ageName
		* @diffMonths pass the member's dob value
		* @isVaccinated pass the boolean value in array format
		**/
		function checkVaccineDoseStatus(value, diffMonths,isVaccinated) {
			var months;
		   if(value==='Birth'){
			   months='0-0';
		   }else{
			  var integer =value.replace(/years?|months|weeks?/g, "").trim();
			   if(value.includes('years')){
				   var arr=integer.split('-');
				   months=parseInt(arr[0])*12+'-'+parseInt(arr[1])*12;	   
			   }else if(value.includes('months')){
				   if(integer.split('-').length===1){
					   months=integer+'-'+integer;
				   }else{
					   months=integer;
				   }
			   }else{
				   var weeks = Math.round(parseInt(integer) / 4.34524);
					months=weeks+'-'+weeks;
			   }
		   }
		   //console.log('monthsmonthsmonths',months);
			var period=months.split('-');
			 if ((diffMonths >= parseInt(period[0]) && diffMonths <= parseInt(period[1])) || (diffMonths >= parseInt(period[0]) && diffMonths >= parseInt(period[1]))) {
				//if(isVaccinated.length !==0){
				  if(isVaccinated.includes(true)){
					return <i className="fa-solid fa-circle-check text-tmGreen" />;	
				  }else{
				    return <i className="fa-solid fa-circle-xmark text-danger" />;
				  }
				//}
			 }
			 else{
			    return <i className="fa-solid fa-circle-h text-secondary" />;
			 }
		 
		}
		
		/** 
		* To find the Missed Vacccination list for particular user
		* @masterValus pass the vacccination masterValue
		* @memberId pass the memberId
		* @memberAge pass the memberAge
		**/
		async function findMissedVaccination(masterValus,memberId,memberAge,lang,t) {
			var vaccinactionList=[];
			var response = await ApiService.getMemberVaccination({id:memberId});
			if(response.status===200 && masterValus){
				// eslint-disable-next-line
				masterValus && masterValus.length !== 0 && masterValus?.vaccinationName.map((name) => {
					// eslint-disable-next-line
				masterValus && masterValus.length !== 0 && masterValus?.vaccinationAge.map((age) => {
					var result=masterValus?.mapping.filter(i=>i.age===age.id && i.vaccination ===name.id);
					if(result.length !==0 && result[0].span !==0 && result[0].span>1){
					var colList=masterValus?.mapping.filter(i=>i.vaccineId===result[0].vaccineId && i.vaccination ===name.id);
					const mergedData1 = [{
						  age: [...new Set(colList.map(obj => obj.age))],
						  dose: [...new Set(colList.map(obj => obj.dose))],
						  vaccination: colList[0].vaccination 
						}];
						// eslint-disable-next-line
					mergedData1.map((a,i)=>{	
					var check= response?.data?.items.filter(i=>a.dose.includes(i.dose) && i.vaccination ===a.vaccination && a.age.includes(parseInt(i.child_age)));
					  if(check.length !==0){
						  //Taken Dose name =console.log('name',name.name,'dose',a.dose[0],'age',a.age);
						  const vaccinaction =lang === 'ta' ? name.name_tamil : name.name+'-'+a.dose[0]+convertIntToSuffix(a.dose[0])+`${t('common.dose')}`;
						  const index = vaccinactionList.findIndex(item => item === vaccinaction);
							if (index !== -1) {
								vaccinactionList.splice(index, 1);
							}
					  }else{
						  var months;
					   if(age.name==='Birth'){
						   months='0-0';
					   }else{
						   var integer =age.name.replace(/years?|months|weeks?/g, "").trim();
							   if(age.name.includes('years')){
								   var arr=integer.split('-');
								   months=parseInt(arr[0])*12+'-'+parseInt(arr[1])*12;	   
							   }else if(age.name.includes('months')){
								   if(integer.split('-').length===1){
									   months=integer+'-'+integer;
								   }else{
									   months=integer;
								   }
							   }else{
								   var weeks = Math.round(parseInt(integer) / 4.34524);
									months=weeks+'-'+weeks;
							   }
					   }
						   var period=months.split('-');
							 if ((memberAge >= parseInt(period[0]) && memberAge <= parseInt(period[1])) || (memberAge >= parseInt(period[0]) && memberAge >= parseInt(period[1]))) {
								 const vaccinaction =lang === 'ta' ? name.name_tamil : name.name+'-'+a.dose[0]+convertIntToSuffix(a.dose[0])+`${t('common.dose')}`;
								 if (!vaccinactionList.includes(vaccinaction)) {
									  vaccinactionList.push(vaccinaction);
									}
							 }
						  }
						  
					 });
					 
					}else{
					 var value= response?.data?.items.filter(i=>parseInt(i.child_age)===age.id && i.vaccination ===name.id); 
					 const mergedArray = result.concat(
						value.filter(obj2 => !result.some(obj1 => obj1.dose === obj2.dose))
						  .map(obj => {
							const { child_age, ...rest } = obj;
							return { ...rest, age: child_age };
						  })
					  );
					  //masterValus?.vaccinationType
					  // eslint-disable-next-line
					  mergedArray.map((a,i)=>{
						var check= response?.data?.items.filter(i=>a.dose === i.dose && i.vaccination ===a.vaccination);
						var typeValue = a && a.type !== 0 ? masterValus?.vaccinationType.find(item => item.id === a.type) : null;
						var typename = typeValue ? typeValue.name : '';
						if(check.length !==0){
							//Taken Dose name =console.log('name',name.name,'dose',a.dose,'age',a.age);
							var dose=a.dose > 4 ? a.dose-4 : a.dose ;
							var doseNames=a.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}` ;
							const vaccinaction =lang === 'ta' ? name.name_tamil : name.name+'-'+typename+dose+convertIntToSuffix(dose)+doseNames;
							const index = vaccinactionList.findIndex(item => item === vaccinaction);
							if (index !== -1) {
								vaccinactionList.splice(index, 1);
							}
						}else{
							var months;
					   if(age.name==='Birth'){
						   months='0-0';
					   }else{
						   var integer =age.name.replace(/years?|months|weeks?/g, "").trim();
							   if(age.name.includes('years')){
								   var arr=integer.split('-');
								   months=parseInt(arr[0])*12+'-'+parseInt(arr[1])*12;	   
							   }else if(age.name.includes('months')){
								   if(integer.split('-').length===1){
									   months=integer+'-'+integer;
								   }else{
									   months=integer;
								   }
							   }else{
								   var weeks = Math.round(parseInt(integer) / 4.34524);
									months=weeks+'-'+weeks;
							   }
					   }
						   var period=months.split('-');
							 if ((memberAge >= parseInt(period[0]) && memberAge <= parseInt(period[1])) || (memberAge >= parseInt(period[0]) && memberAge >= parseInt(period[1]))) {
								 var doses=a.dose > 4 ? a.dose-4 : a.dose ;
								 var doseName=a.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}` ;
									 const vaccinaction =lang === 'ta' ? name.name_tamil : name.name+'-'+typename+doses+convertIntToSuffix(doses)+doseName;
									if (!vaccinactionList.includes(vaccinaction)) {
										vaccinactionList.push(vaccinaction);
									}
							 }
						}
					  });
					}
				});
				});

			}
			return vaccinactionList;
		}
		
	/** 
	* To find the Vital name using category value
	* @category pass the Vital master id
	**/
	function getVitalsName(category, t) {
		switch (category) {
		case 1:
			return `${t('table.heartRate')}`;
		case 2:
			return `${t('table.bloodGlucose')}`;
		case 3:
			return `${t('table.temperature')}`
		case 4:
			return `${t('common.bloodPressure')}`;
		default:
			return category;
		}
	}
	
	/** 
	* To add the Vital value with category's unit value
	* @category pass the Vital master id
	* @value pass the value
	**/
	function getVitalsUnit(category,value) {
		switch (category) {
		case 1:
			return value+' (bpm)';
		case 2:
			return value+' (mg/dL)';
		case 3:
			// Convert Celsius to Fahrenheit: F = (C * 9/5) + 32
			const fahrenheit = Math.round((value * 9/5) + 32);
			return `${fahrenheit} °F`;
		default:
			return value;
		}
	}
	
	/** 
	* This function is used to calculate dob category
	* @dob - pass the member dob
	**/
	function calculateAge(dob){
		const birthDate = new Date(dob);
		const currentDate = new Date();

		// Calculate the difference in months
		const diffMonths = (currentDate.getFullYear() - birthDate.getFullYear()) * 12 + (currentDate.getMonth() - birthDate.getMonth());

		// Calculate years and the remaining months
		const years = Math.floor(diffMonths / 12);
		const months = diffMonths % 12;
		if( 0 <= months && months <= 6 && years===0 ){
			return 1;
		}else if ( 0 <= months && years <= 2 && ( years===0 || years===1) ){
			return 2;
		}else if( 0 <= months && years <= 5 && years === 2){
			return 3;
		}
	}
	
	/** 
	* This function is used to get the labels for weekks,months and years 
	* @a - pass the label name
	**/
	function getLabel(a){
		var value ='';
		var number;
		if(a !==''){
			if (a.includes('week') || a.includes('weeks') || a.includes('Week') || a.includes('Weeks')) {
			  number = parseInt(a);
			  if (!isNaN(number)) {
				value = number === 1 || number === 0 ? number + " Week" : number + " Weeks";
			  }
			} else if (a.includes('month') || a.includes('months') || a.includes('Mon') || a.includes('Mons')) {
			  number = parseInt(a);
			  if (!isNaN(number)) {
				value = number === 1 ? number + " Month" : number + " Months";
			  }
			} else if (a.includes('year') || a.includes('years') || a.includes('Yr') || a.includes('Yrs')) {
			  number = parseInt(a);
			  if (!isNaN(number)) {
				value = number === 1 ? number + " Year" : number + " Years";
			  }
			}
		}
		return value;
	}
	
	/** 
	* This function is used to convert the utc date 
	* @utc - pass the utc value
	**/
	
	function convertUTCtoDate(utc) {
		const date = new Date(utc);
		const formattedDate = date.toLocaleString("en-US", {
		  day: "numeric",
		  month: "short"
		});
		return formattedDate;
	}
	/**
	*Here's an example of how you can get the country code from a dial code in a React component using libphonenumber-js:
	**/
  function getCountryCodeFromDialCode(dialCode){
	  const phoneNumberUtil = PhoneNumberUtil.getInstance();
      const phoneNumber = phoneNumberUtil.parse(`+${dialCode}`, '');
	   if (phoneNumber && phoneNumber.getCountryCode()) {
        const countryCodeNumber = parseInt(phoneNumber.getCountryCode());
        const countryCode = phoneNumberUtil.getRegionCodeForCountryCode(countryCodeNumber);
        return countryCode.toLowerCase();
      }
	return null;
  }

  	
  	//To generate Random UUID
	function generateRandomId(){
		let id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		  const r = Math.floor(Math.random() * 16);
		  const v = c === 'x' ? r : ((r & 0x3) | 0x8);
		  return v.toString(16);
		});
		return id;
	}
	
	//Calculate Age in Months
	function calculateAgeInMonths(dob) {
		console.log("ODB -> ", dob);
	  const today = new Date();
	  const birthDate = new Date(dob);
	  console.log("birth -> ",birthDate);
	  const ageInMonths = (today.getFullYear() - birthDate.getFullYear()) * 12 + 
						  (today.getMonth() - birthDate.getMonth());
	console.log("ageIn month -> ",ageInMonths);						  
	  return ageInMonths < 0 ? 0 : ageInMonths; // Handle negative age
	}
	
	
	// This function is used filtered development Age ranges
	function getFilteredAgeRange(ageInMonths,t) {
		const ageRanges = [
		{ id: 1, name: `0-2 ${t('common.months')}`, min: 0, max: 2, age_range:1 },
		{ id: 2, name: `2-4 ${t('common.months')}`, min: 3, max: 4, age_range:2 },
		{ id: 3, name: `4-6 ${t('common.months')}`, min: 5, max: 6, age_range:3 },
		{ id: 4, name: `6-9 ${t('common.months')}`, min: 7, max: 9, age_range:4 },
		{ id: 5, name: `9-12 ${t('common.months')}`, min: 10, max: 12, age_range:5 },
		{ id: 6, name: `12-15 ${t('common.months')}`, min: 13, max: 15, age_range:6 },
		{ id: 7, name: `15-18 ${t('common.months')}`, min: 16, max: 18, age_range:7 },
		{ id: 8, name: `18 ${t('common.months')} -2 ${t('common.years')}`, min: 19, max: 24, age_range:8 },
		{ id: 9, name: `2 ${t('common.years')} -2.5 ${t('common.years')}`, min: 24, max: 36, age_range:9 },
		{ id: 10, name: `2.5 ${t('common.years')} -3 ${t('common.years')}`, min: 30, max: 36, age_range:10 },
		];
		const filteredAgeRanges = ageRanges.filter((range) => range.min <= ageInMonths || range.min === ageInMonths + 1);
		console.log("Filter : ",filteredAgeRanges);

		return filteredAgeRanges.length > 0 ? filteredAgeRanges : null; 
	}
	
	//Calculate Age in weeks within dob and vaccination selected date
	function calculateAgeWeeks(dob,value) {
		const dobVal = new Date(dob);
		const today = new Date(value);
		const diffInMs = today.getTime() - dobVal.getTime();
		const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
		const ageInWeeks = Math.floor(diffInDays / 7);
		return ageInWeeks;
	}
	
	//This function is used filtered vaccination Age ranges
	function filterAgeRanges (ageInWeeks,vaccinationRange ){
		const filRange = vaccinationRange.filter((range) => range.age_range <=ageInWeeks);
		return filRange.length>0 ? filRange :null;
	}
	
	  // Function to calculate age range based on date of birth
	  const calculateAgeRange = (dob, measurementDate) => {
		
		// Convert DOB string to Date object
		const dobDate = new Date(dob);
		// Convert measurement date string to Date object
		const measurementDateObj = new Date(measurementDate);
	  
		// Calculate the difference in weeks
		const timeDifference = Math.abs(measurementDateObj.getTime() - dobDate.getTime());
		const diffWeeks = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 7));
	  
		// Calculate age range
		let ageRange;
		if (diffWeeks <= 0) {
			ageRange = 1; // Within or equal to the first week
		  } else if (diffWeeks <= 1) {
			ageRange = 2; // Within or equal to the second week
		  } else if (diffWeeks <= 2) {
			ageRange = 3; // Within or equal to the third week
		  } else if (diffWeeks <= 3) {
			ageRange = 4; // Within or equal to the fourth week
		  } else if (diffWeeks <= 4) {
			ageRange = 5; // Within or equal to the fifth week
		  } else if (diffWeeks <= 5) {
			ageRange = 6; // Within or equal to the sixth week
		  } else if (diffWeeks <= 6) {
			ageRange = 7; // Within or equal to the seventh week
		  } else if (diffWeeks <= 7) {
			ageRange = 8; // Within or equal to the eighth week
		  } else if (diffWeeks <= 8) {
			ageRange = 9; // Within or equal to the ninth week
		  } else if (diffWeeks <= 9) {
			ageRange = 10; // Within or equal to the tenth week
		  } else if (diffWeeks <= 10) {
			ageRange = 11; // Within or equal to the eleventh week
		  } else if (diffWeeks <= 11) {
			ageRange = 12; // Within or equal to the twelfth week
		  } else if (diffWeeks <= 12) {
			ageRange = 13; // Within or equal to the thirteenth week
		  } else if (diffWeeks <= 17) {
			ageRange = 14; // Within or equal to 4 months
		  } else if (diffWeeks <= 22) {
			ageRange = 15; // Within or equal to 5 months
		  } else if (diffWeeks <= 26) {
			ageRange = 16; // Within or equal to 6 months
		  } else if (diffWeeks <= 30) {
			ageRange = 17; // Within or equal to 7 months
		  } else if (diffWeeks <= 34) {
			ageRange = 18; // Within or equal to 8 months
		  } else if (diffWeeks <= 39) {
			ageRange = 19; // Within or equal to 9 months
		  } else if (diffWeeks <= 43) {
			ageRange = 20; // Within or equal to 10 months
		  } else if (diffWeeks <= 47) {
			ageRange = 21; // Within or equal to 11 months
		  } else if (diffWeeks <= 56) {
			ageRange = 22; // Within or equal to 1 year
		  } else if (diffWeeks <= 60) {
			ageRange = 23; // Within or equal to 1 year and 1 month
		  } else if (diffWeeks <= 64) {
			ageRange = 24; // Within or equal to 1 year and 2 months
		  } else if (diffWeeks <= 68) {
			ageRange = 25; // Within or equal to 1 year and 3 months
		  } else if (diffWeeks <= 72) {
			ageRange = 26; // Within or equal to 1 year and 4 months
		  } else if (diffWeeks <= 76) {
			ageRange = 27; // Within or equal to 1 year and 5 months
		  } else if (diffWeeks <= 80) {
			ageRange = 28; // Within or equal to 1 year and 6 months
		  } else if (diffWeeks <= 84) {
			ageRange = 29; // Within or equal to 1 year and 7 months
		  } else if (diffWeeks <= 88) {
			ageRange = 30; // Within or equal to 1 year and 8 months
		  } else if (diffWeeks <= 92) {
			ageRange = 31; // Within or equal to 1 year and 9 months
		  } else if (diffWeeks <= 96) {
			ageRange = 32; // Within or equal to 1 year and 10 months
		  } else if (diffWeeks <= 100) {
			ageRange = 33; // Within or equal to 1 year and 11 months
		  } else if (diffWeeks <= 108) {
			ageRange = 34; // Within or equal to 2 years
		  } else if (diffWeeks <= 131) {
			ageRange = 35; // Within or equal to 2 years and 2 months
		  } else if (diffWeeks <= 139) {
			ageRange = 36; // Within or equal to 2 years and 4 months
		  } else if (diffWeeks <= 147) {
			ageRange = 37; // Within or equal to 2 years and 6 months
		  } else if (diffWeeks <= 155) {
			ageRange = 38; // Within or equal to 2 years and 8 months
		  } else if (diffWeeks <= 163) {
			ageRange = 39; // Within or equal to 2 years and 10 months
		  } else if (diffWeeks <= 171) {
			ageRange = 40; // Within or equal to 3 years
		  } else if (diffWeeks <= 179) {
			ageRange = 41; // Within or equal to 3 years and 2 months
		  } else if (diffWeeks <= 187) {
			ageRange = 42; // Within or equal to 3 years and 4 months
		  } else if (diffWeeks <= 195) {
			ageRange = 43; // Within or equal to 3 years and 6 months
		  } else if (diffWeeks <= 203) {
			ageRange = 44; // Within or equal to 3 years and 8 months
		  } else if (diffWeeks <= 211) {
			ageRange = 45; // Within or equal to 3 years and 10 months
		  } else if (diffWeeks <= 219) {
			ageRange = 46; // Within or equal to 4 years
		  } else if (diffWeeks <= 227) {
			ageRange = 47; // Within or equal to 4 years and 2 months
		  } else if (diffWeeks <= 235) {
			ageRange = 48; // Within or equal to 4 years and 4 months
		  } else if (diffWeeks <= 243) {
			ageRange = 49; // Within or equal to 4 years and 6 months
		  } else if (diffWeeks <= 251) {
			ageRange = 50; // Within or equal to 4 years and 8 months
		  } else if (diffWeeks <= 259) {
			ageRange = 51; // Within or equal to 4 years and 10 months
		  } else {
			ageRange = 52; // Over 4 years and 10 months
		  }
		  
		  // If diffWeeks is above 108 and less than 259, add 1 to ageRange, otherwise, use months for age calculation
          ageRange = (diffWeeks > 108 && diffWeeks <= 235) ? ageRange + 1 :  ageRange;

		return ageRange;
	  };

	  function generateRandomPassword() {
		const length = 8; // Set the desired length of the password
		const upperCaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		const lowerCaseChars = 'abcdefghijklmnopqrstuvwxyz';
		const numberChars = '0123456789';
		const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';
	
		// Ensure at least one character from each required set
		let password = [
			upperCaseChars[Math.floor(Math.random() * upperCaseChars.length)],
			lowerCaseChars[Math.floor(Math.random() * lowerCaseChars.length)],
			numberChars[Math.floor(Math.random() * numberChars.length)],
			specialChars[Math.floor(Math.random() * specialChars.length)],
		];
	
		// Fill the remaining length with random characters from all sets
		const allChars = upperCaseChars + lowerCaseChars + numberChars + specialChars;
		for (let i = password.length; i < length; i++) {
			password.push(allChars[Math.floor(Math.random() * allChars.length)]);
		}
	
		// Shuffle the password array to ensure randomness
		password = password.sort(() => Math.random() - 0.5);
	
		// Convert array to string
		return password.join('');
	}	

	//Measurement age range 
	const ageRangeMap = {
		0:"Birth",1: "1 Week", 2: "2 Weeks",3: "3 Weeks",4: "4 Weeks",5: "5 Weeks",6: "6 Weeks",7: "7 Weeks",8: "8 Weeks",9: "9 Weeks",10: "10 Weeks",11: "11 Weeks",12: "12 Weeks",13: "13 Weeks",14: "4 Months",15: "5 Months",	16: "6 Months",	17: "7 Months",	18: "8 Months",19: "9 Months",20: "10 Months",21: "11 Months",22: "1 Year",	23: "1 Yr 1 Month",	24: "1 Yr 2 Months",25: "1 Yr 3 Months",26: "1 Yr 4 Months",27: "1 Yr 5 Months",28: "1 Yr 6 Months",29: "1 Yr 7 Months",30: "1 Yr 8 Months",31: "1 Yr 9 Months",32: "1 Yr 10 Months",33: "1 Yr 11 Months",34: "2 Years",35: "2 Yr 2 Months",36: "2 Yr 4 Months",37: "2 Yr 6 Months",38: "2 Yr 8 Months",39: "2 Yr 10 Months",40: "3 Years",41: "3 Yr 2 Months",42: "3 Yr 4 Months",43: "3 Yr 6 Months",44: "3 Yr 8 Months",45: "3 Yr 10 Months",46: "4 Years",47: "4 Yr 2 Months",48: "4 Yr 4 Months",49: "4 Yr 6 Months",50: "4 Yr 8 Months",51: "4 Yr 10 Months",52: "5 Years"
	};
	
	//To find member age using Measurement age range 
	function printMeasurementAge(age_range) {
		return ageRangeMap[age_range] || "Above 5 Years";
	}

	/**
	 * Checks if a specified time range for a physician is booked and optionally triggers a modal.
	 *
	 * @param {string} physicianId - Physician's unique ID.
	 * @param {Array<string>} days - Days the time range applies to.
	 * @param {string} startTime - Start time in HH:mm format.
	 * @param {string} endTime - End time in HH:mm format.
	 * @param {Array<string>} outOfOffice - Optional out-of-office times (default: []).
	 * @param {Function} onModalShow - Callback triggered with booked appointments if time is unavailable.
	 * 
	 * @returns {Promise<boolean>} - `true` if booked (modal triggered), `false` if available.
	 */
	const handleBookedAppointmentCheck = async (physicianId, days, startTime, endTime, outOfOffice, onModalShow, timeZone, module) => {
			try {
			// Add outOfOffice to your request
			const requestData = {
				physicianId,
				days,
				startTime,
				endTime,
				outOfOffice: outOfOffice || [],
				timeZone: timeZone || 'UTC',
				module: module || 'days',
			};
			// API request
			const response = await ApiService.getBookedAppointmentDetails(requestData);
			if (response?.data?.isBooked) {
				// If the appointment is booked, trigger the modal
				onModalShow(response?.data?.bookedAppointments);
				return true;  // Return true to indicate that we should not continue the logic
			}
			return false;  // Return false to indicate that we can proceed with the remaining logic
			} catch (error) {
			console.error("Error checking booked appointments:", error);
			return false;
			}
	};

	//This function is convert date flatPicker format to date format
	function flatPickerFormatDate (date){
		if (date instanceof Date) {
			// Convert Date object to YYYY-MM-DD format
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
			const day = String(date.getDate()).padStart(2, "0");
			return `${year}-${month}-${day}`;
		} else if (typeof date === "string") {
			// If it's a string, trim it and return as-is
			return date.trim();
		}
		return ""; // Handle unexpected types
	};

export  {generatePrivateKey,hashPassword,generatePasswordEPK,goBack,dataURItoBlob,convertTimeFormat,generateSharedKey ,convertDOBtoAge,convertUTCtoLocal,convertDOBtoDevStage,convertDOBtoAgerangeId,convertDOBtoMonth,checkMilestoneAnswer,convertDateToTime,convertTimeToDate,convert_DateToTime,formatMeasurement,convertS3privateToPublic,analyticsRequest,getBrowserInfo,filterGeoLocation,lastSeen,getMessageDate,appointmentEventdates,convertUTCtoLocalDigit,decryptPassword,encryptPassword,convertUTCtoDateAndTime,convertIntToSuffix,printVaccinationDose,checkColumnSpanSize,checkVaccineDoseStatus,findMissedVaccination,getVitalsName,getVitalsUnit,calculateAge,getLabel,convertUTCtoDate,getCountryCodeFromDialCode,generateRandomId,calculateAgeInMonths,getFilteredAgeRange,calculateAgeWeeks,filterAgeRanges,calculateAgeRange,getRandomHexString,generateRandomPassword,printMeasurementAge,handleBookedAppointmentCheck,flatPickerFormatDate,getMakeFromBrowser};